import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-update-worker-additional-info',
	templateUrl: './modal-update-worker-additional-info.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalUpdateWorkerAdditionalInfoComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalUpdateWorkerAdditionalInfoComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.getName = this.getName;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		
		this.initialize();
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_INIT']);
		
		this.vm.uid = 'tuw-' + Date.now();
		this.vm.additionalInfo = this.vm.isSecond ? this.vm.invitation.additionalInfo2 : this.vm.invitation.additionalInfo;
		this.vm.user = this.session.getSession().user;
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_DELAY']);
		
		this.vm.initialized = true;
	}
	
	getName() {
		return this.vm.invitation ? this.vm.invitation.firstName + ' ' + this.vm.invitation.lastName : '';
	}
	
	submit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing || !this.vm.initialized) return;
		this.vm.processing = true;
		
		var invitation: any = {};
		invitation.id = this.vm.invitation.id;
		if (this.vm.isSecond) {
			invitation.additionalInfo2 = this.vm.additionalInfo;
		} else {
			invitation.additionalInfo = this.vm.additionalInfo;
		}
		
		var successCallback = (response) => {
			if (this.vm.isSecond) {
				this.vm.invitation.additionalInfo2 = this.vm.additionalInfo;
			} else {
				this.vm.invitation.additionalInfo = this.vm.additionalInfo;
			}
			this.vm.invitation.processing = false;
			this.dialogRef.close(response);
		};
		var errorCallback = (error) => {
			console.log(error);
			this.vm.processing = false;
		};
		
		if (this.vm.isSecond) {
			if (this.vm.invitation.isDependent) {
				this.restService.saveBusinessClientUserUpdateDependentAdditionalInfo2(invitation).then(successCallback).catch(errorCallback);
			} else {
				this.restService.saveBusinessClientUserUpdateAdditionalInfo2(invitation).then(successCallback).catch(errorCallback);
			}
		} else {
			if (this.vm.invitation.isDependent) {
				this.restService.saveBusinessClientUserUpdateDependentAdditionalInfo(invitation).then(successCallback).catch(errorCallback);
			} else {
				this.restService.saveBusinessClientUserUpdateAdditionalInfo(invitation).then(successCallback).catch(errorCallback);
			}
		}

	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}